import React, { VFC } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';

import { inputBorderStyling } from 'components/sections/ControlHero/inputBorderStyling';
import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';
import { Gutter } from 'components/Gutter';
import { arrowRight } from 'icons/default';

import styles from './LicensePlate.module.scss';

interface ILicensePlate {
  licensePlate: string;
  isLoggedIn: boolean;
}

export const LicensePlate: VFC<ILicensePlate> = ({ licensePlate, isLoggedIn }) => {
  const router = useRouter();
  const url = router.asPath;
  return (
    <dl className={styles['dl-wrapper']}>
      <div>
        {isLoggedIn ? (
          <div className={styles['number-plate']}>
            <Image
              src="/assets/images/number-plate.svg"
              alt="Number plate"
              width={30}
              height={60}
            />
            <input
              id="licensePlate"
              type="text"
              maxLength={6}
              autoComplete="off"
              style={inputBorderStyling[6]}
              value={licensePlate}
              disabled
            />
          </div>
        ) : (
          <>
            <dt className={styles.dt}>Visas för inloggade</dt>
            <dd className={styles.license_plate}>
              <span>Registreringsnummer</span>
            </dd>
            <Gutter size="tiny" />
            <Button
              type={ButtonType.Button}
              size={ButtonSize.Large}
              trailingIcon={arrowRight}
              href={`/app/forward?page=${url}`}
              nofollow
              variant={ButtonVariant.PrimaryMintSweet}
            >
              Logga in
            </Button>
          </>
        )}
      </div>
    </dl>
  );
};
